import * as types from '../../action-types';
import {deleteEducation as initialState } from "../../initialState";

const deleteEducation = (state=initialState, action) => {
  switch (action.type) {
    case types.DELETE_EDUCATION_START:
      return {
        ...state,
        isLoading: true
      };
    case types.DELETE_EDUCATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.DELETE_EDUCATION_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.DELETE_EDUCATION_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default deleteEducation;
